import { GuestCardDetails } from "../guestCardTypes"

export enum GuestInfoState {
    CHECKED_IN = "CHECKED_IN",
    CHECKED_OUT = "CHECKED_OUT",
    PENDING = "PENDING",
    EXPECTED = "EXPECTED",
}

export enum GuestInfoType {
    SINGLE = "SINGLE",
    GROUP = "GROUP",
}

export type HostCompany = Readonly<{
    id: number
    name: string
}>

export type GuestHost = Readonly<{
    id: number
    displayName: string
    company: HostCompany
}>

export type SingleAttendee = Readonly<{
    id: number
    name: string
    email: string
    company: string
}>

export type GroupAttendee = Readonly<{
    id: number
    name?: string
    company: string
    count: number
}>

export type GuestOrder = Readonly<{
    id: number
    meetingDetails: Readonly<{
        meetingName: string
    }>
}>

export type GuestTimeline = Readonly<{
    created?: string
    meetingTime?: string
    arrivalTime?: string
    checkInTime?: string
    checkOutTime?: string
}>

export type MeetingDetails = Readonly<{
    meetingName: string
}>

export type GuestInfoSingle = Readonly<{
    state: GuestInfoState
    type: GuestInfoType.SINGLE
    attendee: SingleAttendee
    host: GuestHost
    order?: GuestOrder
    timeline: GuestTimeline
    guestCardDetails?: GuestCardDetails
}>

export type GuestInfoGroup = Readonly<{
    state: GuestInfoState
    type: GuestInfoType.GROUP
    attendee: GroupAttendee
    host: GuestHost
    order?: GuestOrder
    timeline: GuestTimeline
    guestCardDetails?: GuestCardDetails
}>

export type GuestInfo = GuestInfoSingle | GuestInfoGroup
